import { Component } from '@angular/core';

@Component({
  selector: 'marketing-message',
  templateUrl: './marketing.component.html',
  styleUrls: ['./marketing.component.css'],
})
export class MarketingComponent {}
